import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '8rem',
});

export const TextContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '11rem',
});

export const LogoText = styled.span(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '20rem',
  fontFamily: "'Open Sans', sans-serif",
  letterSpacing: '0',
  color: theme.header.primaryAccent.text,
  opacity: 1,
}));
